import simpleCgi from './lib/simpleCgi';

export default class extends simpleCgi {
  constructor(opt) {
    super(opt);
  }

  aesKeys() {
    return ['openid', 'openkey', 'session_id', 'session_type'];
  }

  cgiName() {
    return 'elec_invoice_service_front';
  }
}
